import Title from '../../microComponents/elements/Title';
import ComponentCard from '../../microComponents/elements/ComponentCard';
import UseSetParams from '../../microComponents/tablePages/filter/UseSetParams';
import DeleteFilterTable from '../../microComponents/tablePages/filter/DeleteFilterTable';
import CreatorTable from '../../microComponents/tablePages/CreatorTable';
import ProductsColumn from './ProductsColumn';
import UpdateCreateProduct from "./UpdateCreateProduct";
import React, {useState} from "react";
import ExpandedPalletStatus from "../PalletStatus/ExpandedPalletStatus";


const Products = () => {
    const [columns] = ProductsColumn();
    const [, handleDeleteParams] = UseSetParams();

    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRowFull, setSelectedRowFull] = useState([]);
    const onSelectChange = (newSelectedRowKeys, x) => {
        setSelectedRowFull(x)
        setSelectedRowKeys(newSelectedRowKeys);
    };
    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,

    };
    return (<div>
            <ComponentCard>
                <div className='flex justify-between'>
                    <Title>محصولات</Title>
                    <div className='flex gap-2 items-center'>
                        <DeleteFilterTable onClick={handleDeleteParams}/>
                        <UpdateCreateProduct rowData={selectedRowFull} selectedRowKeys={selectedRowKeys}/>
                        {/*<UpdateCreateProduct rowData={selectedRows} selectedRowKeys={selectedRows}/>*/}
                    </div>
                </div>
            </ComponentCard> <ComponentCard>

            <CreatorTable rowKey={'code'} columns={columns} rowSelection={{
                type: "checkbox",
                preserveSelectedRowKeys: true,
                ...rowSelection,
            }} listAddress='Product'
                          expandable={{
                              expandedRowRender: (row) => (
                                  <ExpandedPalletStatus item={row}/>
                              ),

                          }}
            />

        </ComponentCard></div>
    );
};


export default Products;
